import { useMutation, useQueryClient, UseMutationResult } from 'react-query'
import {
  createPoliDirectDebit,
  verifyPoliTransaction,
  createBlinkpayDirectDebit,
  verifyBlinkpayTransaction,
  verifyStripeTransaction
} from 'api/transfers'

export function useMutatePoliDirectDebit(): UseMutationResult<
  { navigationUrl: string },
  unknown,
  { amount: number; productId: number }
> {
  return useMutation(createPoliDirectDebit)
}

export function useMutateVerifyPoliTransaction(): UseMutationResult<
  { success: boolean; message: string; transactionStatus: string },
  unknown,
  string
> {
  const qc = useQueryClient()
  return useMutation(verifyPoliTransaction, {
    onSuccess: () => {
      qc.invalidateQueries(['wallet'])
    }
  })
}

export function useMutateBlinkpayDirectDebit(): UseMutationResult<
  { navigationUrl: string; quickPaymentId: string },
  unknown,
  { amount: number; productId: number }
> {
  return useMutation(createBlinkpayDirectDebit)
}

export function useMutateVerifyBlinkpayTransaction(): UseMutationResult<
  { success: boolean; message: string; transactionStatus: string },
  unknown,
  string
> {
  const qc = useQueryClient()
  return useMutation(verifyBlinkpayTransaction, {
    onSuccess: () => {
      qc.invalidateQueries(['wallet'])
    }
  })
}

export function useMutateVerifyStripeTransaction(): UseMutationResult<
  { success: boolean; transactionStatus: string },
  unknown,
  string
> {
  const qc = useQueryClient()
  return useMutation(verifyStripeTransaction, {
    onSuccess: () => {
      qc.invalidateQueries(['wallet'])
    }
  })
}
